import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { WebTemplatesModel } from '../../Models/Models/Common/WebTemplatesModel';

declare var IS_RUNNING_IN_APP_POOL;

export class WebTemplatesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(descriptionName: string): Promise<WebTemplatesModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Common/WebTemplates/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { descriptionName: descriptionName }

    return AjaxWrapper.get<WebTemplatesModel, any>(url, data);
  }
}

